module.exports = __webpack_public_path__ + "img/conveyor-belt-empty.a41eea1c.svg";